module.exports = {
	"version": "1.2080.8",
	"manifest": {
		"adminLoginButton": "1.2010.8",
		"animations": "1.2080.8",
		"audioCommon": "1.2080.8",
		"audioPlayer": "1.2080.8",
		"backToTopButton": "1.2010.8",
		"backgroundCommon": "1.2080.8",
		"balata": "1.2080.8",
		"balataCommon": "1.2080.8",
		"boxSlideShowSlide": "1.2080.8",
		"buttonCommon": "1.2080.8",
		"clipArt": "1.2010.8",
		"column": "1.2010.8",
		"comboBoxInput": "1.2080.8",
		"compDesignUtils": "1.2080.8",
		"compUtils": "1.2080.8",
		"components": "1.2080.8",
		"componentsPreviewLayer": "1.2080.8",
		"contactForm": "1.2080.8",
		"container": "1.2010.8",
		"containerCommon": "1.2010.8",
		"core": "1.2080.8",
		"coreUtils": "1.2080.8",
		"dataFixer": "1.2080.8",
		"datePicker": "1.2080.8",
		"dateUtils": "1.2010.8",
		"deadComponent": "1.2040.17",
		"displayer": "1.2080.8",
		"documentMedia": "1.2080.8",
		"documentServices": "1.2080.8",
		"editingRendererPlugins": "1.2010.8",
		"exitMobileModeButton": "1.2080.8",
		"facebookComments": "1.2080.8",
		"facebookLike": "1.2010.8",
		"facebookLikeBox": "1.2010.8",
		"fileUploader": "1.2080.8",
		"fonts": "1.2080.8",
		"fontsPrefetch": "1.2010.8",
		"footerContainer": "1.2010.8",
		"formCommon": "1.2080.8",
		"galleriesCommon": "1.2080.8",
		"googleMap": "1.2080.8",
		"groupContainer": "1.2040.17",
		"headerContainer": "1.2010.8",
		"htmlComponent": "1.2080.8",
		"image": "1.2080.8",
		"imageButton": "1.2040.17",
		"imageClientApi": "1.2010.8",
		"imageCommon": "1.2080.8",
		"layout": "1.2080.8",
		"linkBar": "1.2080.8",
		"loggingUtils": "1.2080.8",
		"loginButton": "1.2010.8",
		"matrixGallery": "1.2080.8",
		"mediaCommon": "1.2080.8",
		"mediaContainer": "1.2080.8",
		"mediaControlFullscreen": "1.2080.8",
		"mediaControlPlay": "1.2080.8",
		"mediaControlProgress": "1.2080.8",
		"mediaControlTime": "1.2080.8",
		"mediaControlVolume": "1.2080.8",
		"mediaControls": "1.2080.8",
		"mediaPlayer": "1.2080.8",
		"page": "1.2080.8",
		"paginatedGridGallery": "1.2080.8",
		"paypalButton": "1.2010.8",
		"pinItPinWidget": "1.2080.8",
		"pinterestFollow": "1.2080.8",
		"pinterestPinIt": "1.2010.8",
		"popupCloseTextButton": "1.2010.8",
		"popupContainer": "1.2080.8",
		"previewExtensionsCore": "1.2080.8",
		"qaAutomation": "1.2080.8",
		"radioButton": "1.2080.8",
		"radioGroup": "1.2080.8",
		"render": "1.2080.8",
		"rssButton": "1.2010.8",
		"santaProps": "1.2080.8",
		"screenWidthContainer": "1.2010.8",
		"server": "1.2010.8",
		"singleAudioPlayer": "1.2080.8",
		"siteBackground": "1.2080.8",
		"siteButton": "1.2080.8",
		"siteUtils": "1.2080.8",
		"skinExports": "1.2080.8",
		"skins": "1.2080.8",
		"slideShowGallery": "1.2080.8",
		"sliderGallery": "1.2080.8",
		"socialCommon": "1.2010.8",
		"soundCloudWidget": "1.2010.8",
		"spotifyFollow": "1.2010.8",
		"spotifyPlayer": "1.2010.8",
		"stripColumnsContainer": "1.2080.8",
		"stripContainer": "1.2080.8",
		"stripSlideShowSlide": "1.2080.8",
		"subscribeForm": "1.2080.8",
		"svgShape": "1.2080.8",
		"testUtils": "1.2080.8",
		"textArea": "1.2080.8",
		"textCommon": "1.2080.8",
		"textInput": "1.2010.8",
		"tinyMenu": "1.2010.8",
		"tpa": "1.2080.8",
		"translationsUtils": "1.2010.12",
		"tweenEngine": "1.2080.8",
		"twitterFeed": "1.2010.8",
		"utils": "1.2080.8",
		"video": "1.2080.8",
		"wPhoto": "1.2080.8",
		"wRichText": "1.2080.8",
		"wTwitterFollow": "1.2010.8",
		"warmup": "1.2080.8",
		"widgets": "1.2080.8",
		"wixCode": "1.2080.8",
		"wixCodeInit": "1.2080.8",
		"wixCodeSeo": "1.2080.8",
		"wixSites": "1.2010.8",
		"wixSkinOnly": "1.2010.8",
		"wixUrlParser": "1.2080.8",
		"wixappsBuilder": "1.2080.8",
		"wixappsClassics": "1.2080.8",
		"wixappsCore": "1.2080.8",
		"zoomedImage": "1.2010.8"
	},
	"versions": {
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"balata",
		"balataCommon",
		"boxSlideShowSlide",
		"buttonCommon",
		"clipArt",
		"column",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"displayer",
		"documentMedia",
		"documentServices",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"fileUploader",
		"fonts",
		"fontsPrefetch",
		"footerContainer",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"groupContainer",
		"headerContainer",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"matrixGallery",
		"mediaCommon",
		"mediaContainer",
		"mediaControlFullscreen",
		"mediaControlPlay",
		"mediaControlProgress",
		"mediaControlTime",
		"mediaControlVolume",
		"mediaControls",
		"mediaPlayer",
		"page",
		"paginatedGridGallery",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"radioButton",
		"radioGroup",
		"render",
		"rssButton",
		"santaProps",
		"screenWidthContainer",
		"server",
		"singleAudioPlayer",
		"siteBackground",
		"siteButton",
		"siteUtils",
		"skinExports",
		"skins",
		"slideShowGallery",
		"sliderGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShowSlide",
		"subscribeForm",
		"svgShape",
		"testUtils",
		"textArea",
		"textCommon",
		"textInput",
		"tinyMenu",
		"tpa",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"video",
		"wPhoto",
		"wRichText",
		"wTwitterFollow",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixSkinOnly",
		"wixUrlParser",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/main/options/viewer.json
// module id = 24
// module chunks = 0